export const sequence = {
    sequence_empty_list: 'لا توجد استبيانات متاحة لهذه الفترة الزمنية.',
};
